import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { QuestionMarkIcon, UploadIcon } from 'Asset/icon';
import { Condition } from 'Component/others';
import ButtonSolid from 'UiKit/button/buttonSolid';
import { TextMedium, TextRegular } from 'UiKit/typography';
import ContentDrawerInfo from 'View/host-presence-content/components/content-drawer-info';

import styles from './styles.module.css';

const OverviewContent = ({ presenceData, taskData }) => {
  const { t } = useTranslation('host-content');
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const { isClockedIn, isTaskSubmitted, isLivestreaming } = presenceData ?? {};

  const shouldShowSubmitButton = !isLivestreaming && isClockedIn && !isTaskSubmitted;

  return (
    <Box className={styles['overview-content__container']}>
      <Box className={styles['overview-content__content']}>
        <Box className={styles['overview-content__text-container']}>
          <TextRegular fontSize="var(--font-caption1)">{t('page.period')}</TextRegular>
          <TextMedium fontSize="var(--font-body3)">{moment(taskData?.monthYear, 'MM-YYYY').format('MMMM YYYY')}</TextMedium>
        </Box>
        <Box className={styles['overview-content__text-container']}>
          <TextRegular fontSize="var(--font-caption1)">{t('page.total_content')}</TextRegular>
          <TextRegular fontSize="var(--font-body3)">
            <span className={styles['overview-content__total-content']}>{taskData?.totalTaskVideos}</span>/{taskData?.totalDays}
          </TextRegular>
        </Box>
        <Box className={styles['overview-content__info']} onClick={() => setIsDrawerOpen(true)}>
          <QuestionMarkIcon />
        </Box>
      </Box>
      <Condition statement={shouldShowSubmitButton}>
        <ButtonSolid className={styles['overview-content__submit-button']} onClick={() => navigate('/host/task-submission')}>
          <UploadIcon size={18} /> {t('page.submit_content')}
        </ButtonSolid>
      </Condition>
      <ContentDrawerInfo isOpen={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} />
    </Box>
  );
};

export default OverviewContent;
